document.addEventListener("DOMContentLoaded", function () {
  const url = new URL(window.location.href);
  const urlParams = url.searchParams;

  const urlRefValue = urlParams.get("provider");

  // Try to get existing provider cookie value
  const providerCookieMatch = document.cookie.match(/(?:^|; )provider=([^;]*)/);
  const currentCookieValue =
    providerCookieMatch && decodeURIComponent(providerCookieMatch[1]);

  // Helper: sanitize to allow only safe characters
  function sanitize(val) {
    return val && val.replace(/[^a-zA-Z0-9_-]/g, "");
  }

  const sanitizedUrlRef = sanitize(urlRefValue);
  const sanitizedCookieRef = sanitize(currentCookieValue);

  // 1) If cookie exists but URL does not have provider param, rewrite URL (no reload)
  if (!sanitizedUrlRef && sanitizedCookieRef) {
    urlParams.set("provider", sanitizedCookieRef);
    // replaceState avoids reload + avoids adding a new history entry
    window.history.replaceState({}, "", url.toString());
  }

  // Decide the effective provider value to use for the rest of the script
  const effectiveProvider = sanitizedUrlRef || sanitizedCookieRef;

  // 2) Keep cookie in sync with effectiveProvider (prefer URL if present)
  if (effectiveProvider) {
    const currentSanitizedCookie = sanitizedCookieRef;
    if (!currentSanitizedCookie || currentSanitizedCookie !== effectiveProvider) {
      document.cookie =
        "provider=" +
        encodeURIComponent(effectiveProvider) +
        "; path=/; max-age=" +
        (60 * 60 * 24 * 30); // 30 days
    }
  }

  // 3) Update all internal links to include the provider param
  if (effectiveProvider) {
    const links = document.querySelectorAll("a[href]");
    links.forEach(function (link) {
      try {
        const linkUrl = new URL(link.href, window.location.origin);

        // Only same-host links
        if (linkUrl.hostname === window.location.hostname) {
          linkUrl.searchParams.set("provider", effectiveProvider);
          link.href = linkUrl.toString();
        }
      } catch (e) {
        console.warn("Skipping link:", link.href, e);
      }
    });
  }

  // 4) Mirror current page URL into share component
  document.querySelectorAll(".social-share").forEach(function (container) {
    const input = container.querySelector(".social-share__input");
    if (input) input.value = window.location.href;

    const copyBtn = container.querySelector(".social-share__copy-url");
    if (copyBtn) copyBtn.dataset.url = window.location.href;
  });
});